// extracted by mini-css-extract-plugin
module.exports = {"infoCard":"InfoCard_infoCard__2NDhL","infoCardWrapper":"InfoCard_infoCardWrapper__q-Pxz"};